module.exports = __webpack_public_path__ + "bundle/fonts/CarroisGothicSC-Regular.ttf";